/**
 * AuthCallback — processes the Emergent Google OAuth return.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React, { useEffect, useRef } from 'react';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || '';
      const m = hash.match(/session_id=([^&]+)/);
      const dest = window.location.pathname || '/';
      if (!m) {
        window.location.replace(dest);
        return;
      }
      try {
        const r = await axios.post(`${API_BASE}/auth/google/session`, { session_id: m[1] });
        localStorage.setItem('user_token', 'cookie-session-user');
        localStorage.setItem('token', 'cookie-session-user');
        if (r.data.user) {
          localStorage.setItem('user', JSON.stringify(r.data.user));
          localStorage.setItem('user_data', JSON.stringify(r.data.user));
        }
      } catch {
        // fall through — land back on the page unauthenticated
      }
      window.location.replace(dest);
    };
    run();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="w-8 h-8 border-2 border-[#1E3F70] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
